export default __webpack_public_path__ + "static/media/스프링바인딩 48P - yellow (72Page).9a5e17ea.png";